<template>
  <div class="timeline-container">
    <!-- 头部 -->
    <div class="timeline-header">
      <div class="header-left">
        <span class="header-title">学习时间线</span>
        <div class="header-nav">
          <button class="nav-btn" @click="scrollLeft" :disabled="scrollLeftDisabled">←</button>
          <button class="nav-btn" @click="scrollRight" :disabled="scrollRightDisabled">→</button>
        </div>
      </div>
      <div class="header-legend">
        <span class="legend-item">
          <span class="legend-dot done"></span> 已完成
        </span>
        <span class="legend-item">
          <span class="legend-dot active"></span> 进行中
        </span>
        <span class="legend-item">
          <span class="legend-dot pending"></span> 待开始
        </span>
      </div>
    </div>

    <!-- 滚动区域 -->
    <div
      class="timeline-scroll"
      ref="timelineScroll"
      @scroll="handleScroll"
    >
      <div class="timeline-body">
        <div class="timeline-rail"></div>
        <div class="timeline-rail-fill" :style="{ width: progressWidth }"></div>

        <!-- 节点列表 -->
        <div class="timeline-nodes">
          <div
            class="tl-node"
            :class="item.status"
            v-for="(item, index) in timelineData"
            :key="item.id"
            :data-index="index"
            @click="handleClick(item)"
          >
            <div class="node-dot-wrap">
              <div class="node-dot"></div>
            </div>
            <div class="node-plate">
              <span class="plate-period">{{ item.periods_text }}</span>
              <span class="badge-active" v-if="item.status === 'active'">进行中</span>
              <div class="plate-time">
                <span class="t-label">开始</span>
                <span class="t-val">{{ formatTime(item.start_time_text).date }} {{ formatTime(item.start_time_text).time }}</span>
                <br />
                <span class="t-label">结束</span>
                <span class="t-val">{{ formatTime(item.end_time_text).date }} {{ formatTime(item.end_time_text).time }}</span>
              </div>

              <div v-if="item.complete_count" class="complate_count">
                <span style="font-size:12px;color:#F56C6C;font-weight:700;">{{ item.complete_count }}人完成本阶段</span>
              </div>

              <!-- 分数/状态展示 -->
              <template v-if="item.status === 'done' && item.fraction !== null && item.fraction !== undefined">
                <span class="plate-score">{{ item.fraction }}分</span>
              </template>
              <!-- <template v-else-if="item.status === 'active'">
                <span class="plate-score score-exam">考核中</span>
              </template>
              <template v-else>
                <span class="plate-score">待考</span>
              </template> -->
              <div class="articl_type">
                <span v-if="item.read_count" class="plate-desc">阅读在线 {{ item.read_count }}</span>
                <span v-if="item.specatily_count" class="plate-desc">应试英语 {{ item.specatily_count }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'TimelineHorizontal',
    props: {
        periods_data: {
            type: Array,
            default: () => []
        },
        periods: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            // 数据源和原生HTML完全一致
            timelineData: [],
            scrollLeftDisabled: false,
            scrollRightDisabled: false,
            progressWidth: '0%',
            activeIndex: -1
        }
    },
    mounted() {
        // // 找到活跃节点索引
        // this.activeIndex = this.timelineData.findIndex(item => item.status === 'active')
        // // 计算进度条
        // this.updateProgress()
        // // 初始化滚动边界检测
        // this.handleScroll()
        // // 自动滚动到活跃节点（延迟确保DOM渲染完成）
        // setTimeout(() => {
        // this.scrollToActive()
        // }, 300)
    },
    watch: {
        periods_data: {
            handler(newVal) {
                this.timelineData = newVal
                // 重新找到活跃节点索引
                this.activeIndex = this.timelineData.findIndex(item => item.status === 'active')
                // 重新计算进度条
                this.updateProgress()
                // 重新初始化滚动边界检测
                this.handleScroll()
                // 自动滚动到活跃节点（延迟确保DOM渲染完成）
                setTimeout(() => {
                this.scrollToActive()
                }, 200)
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        // 时间格式化（和原生JS完全一致）
        formatTime(isoTime) {
        if (!isoTime) return { date: '-', time: '-' }
        const parts = isoTime.split(' ')
        const datePart = parts[0] || ''
        const timePart = parts[1] || ''
        const segs = datePart.split('-')
        const shortDate = segs.length === 3 
            ? segs[0].slice(2) + '/' + segs[1] + '/' + segs[2] 
            : datePart
        return { date: shortDate, time: timePart }
        },

        // 更新进度条宽度
        updateProgress() {
            if (this.activeIndex < 0 || this.timelineData.length <= 1) {
                
                this.progressWidth = '0%'
                return
            }
            const percent = (this.activeIndex / (this.timelineData.length - 1)) * 100
            this.progressWidth = `${percent}%`
        },

        // 向左滚动
        scrollLeft() {
            this.$refs.timelineScroll.scrollBy({ left: -300, behavior: 'smooth' })
        },

        // 向右滚动
        scrollRight() {
            this.$refs.timelineScroll.scrollBy({ left: 300, behavior: 'smooth' })
        },

        // 检测滚动边界
        handleScroll() {
            const el = this.$refs.timelineScroll
            if (!el) return
            const { scrollLeft, scrollWidth, clientWidth } = el
            this.scrollLeftDisabled = scrollLeft <= 10
            this.scrollRightDisabled = (scrollWidth - scrollLeft - clientWidth) <= 10
        },

        // 自动滚动到活跃节点
        scrollToActive() {
            if (this.activeIndex < 0) return
            const el = this.$refs.timelineScroll
            if (!el) return
            
            const allNodes = el.querySelectorAll('.tl-node')
            const activeNode = allNodes[this.activeIndex]
            if (!activeNode) return

            const nodeLeft = activeNode.offsetLeft
            const nodeWidth = activeNode.offsetWidth
            const containerWidth = el.clientWidth
            const target = nodeLeft - containerWidth / 2 + nodeWidth / 2

            el.scrollTo({ left: Math.max(0, target), behavior: 'smooth' })
        },

        handleClick(item){
            this.$emit('selectPeriod', item)
        }
    }
}
</script>

<!-- 移除scoped，确保样式和原生HTML完全一致（避免样式隔离问题） -->
<style>
:root {
  --blue-50: #f0f5ff;
  --blue-100: #dce8fc;
  --blue-200: #b8d2f8;
  --blue-300: #8ab8f2;
  --blue-400: #5a9eeb;
  --blue-500: #3b82f6;
  --blue-600: #2563eb;
  --blue-700: #1d4ed8;
  --blue-800: #1e40af;
  --gray-50: #f9fafb;
  --gray-100: #f3f4f6;
  --gray-200: #e5e7eb;
  --gray-300: #d1d5db;
  --gray-400: #9ca3af;
  --gray-500: #6b7280;
  --gray-600: #4b5563;
  --gray-700: #374151;
  --gray-800: #1f2937;
  --white: #ffffff;
  --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.04);
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.04);
  --shadow-lg: 0 10px 30px rgba(0, 0, 0, 0.09), 0 4px 10px rgba(0, 0, 0, 0.04);
  --shadow-glow: 0 0 0 8px rgba(59, 130, 246, 0.15), 0 0 30px rgba(59, 130, 246, 0.25);
  --radius-xs: 6px;
  --radius-sm: 10px;
  --radius-md: 14px;
  --radius-lg: 20px;
  --radius-xl: 24px;
  --radius-full: 9999px;
  --transition-fast: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  --transition-smooth: 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  --font-mono: 'SF Mono', 'Fira Code', 'Menlo', 'Consolas', 'Monaco', 'PingFang SC', monospace;
}
.active{
    border-bottom: 0px;
}

/* ==================== 主容器 ==================== */
.timeline-container {
  width: 100%;
  background: var(--white);
  border-radius: var(--radius-xl);
  overflow: hidden;
  padding: 20px;
  margin-top: 20px;
}


/* ==================== 头部 ==================== */
.timeline-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 34px;
  flex-wrap: wrap;
  gap: 14px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--gray-800);
  letter-spacing: 0.2px;
}

.header-legend {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 12.5px;
  color: var(--gray-500);
  flex-wrap: wrap;
}

/* 新增：导航按钮组 */
.header-nav {
  display: flex;
  gap: 8px;
  margin-left: 16px;
}
.nav-btn {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
  border: 1px solid var(--gray-200);
  background: var(--gray-50);
  color: var(--gray-600);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition-fast);
}
.nav-btn:hover {
  background: var(--blue-50);
  border-color: var(--blue-200);
  color: var(--blue-600);
}
.nav-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: var(--gray-100);
  border-color: var(--gray-200);
  color: var(--gray-400);
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: var(--radius-full);
  flex-shrink: 0;
}
.legend-dot.done {
  background: var(--blue-500);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}
.legend-dot.active {
  background: #fff;
  border: 2.5px solid var(--blue-600);
  box-shadow: 0 0 0 5px rgba(37, 99, 235, 0.2);
  animation: legendPulse 2.2s ease-in-out infinite;
}
.legend-dot.pending {
  background: #fff;
  border: 2px solid var(--gray-300);
}

@keyframes legendPulse {
  0%,
  100% {
    box-shadow: 0 0 0 5px rgba(37, 99, 235, 0.2);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(37, 99, 235, 0.06);
  }
}

/* ==================== 滚动区 ==================== */
.timeline-scroll {
  overflow-x: auto;
  overflow-y: visible;
  padding-bottom: 16px;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

/* 自定义滚动条样式 */
.timeline-scroll::-webkit-scrollbar {
  height: 6px;
}

.timeline-scroll::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.timeline-scroll::-webkit-scrollbar-thumb {
  background: rgba(64, 158, 255, 0.3); /* 蓝色半透明 */
  border-radius: 3px;
}

.timeline-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(64, 158, 255, 0.5); /* 悬停时透明度降低 */
}


/* ==================== 时间线主体 ==================== */
.timeline-body {
  position: relative;
  /* 移除固定最小宽度，改为自适应 */
  min-width: fit-content;
  padding-top: 40px;
  padding-bottom: 6px;
  /* 多节点时增加左右内边距 */
  padding-left: 16px;
  padding-right: 16px;
}

/* 轨道 - 适配多节点 */
.timeline-rail {
  position: absolute;
  top: 56px;
  left: 16px;
  /* 轨道长度适配节点容器 */
  right: 16px;
  height: 2px;
  background: var(--gray-200);
  border-radius: 10px;
  z-index: 0;
}

/* 进度填充 */
.timeline-rail-fill {
  position: absolute;
  top: 56px;
  left: 16px;
  height: 2.5px;
  background: linear-gradient(90deg, var(--blue-400), var(--blue-500), var(--blue-600));
  border-radius: 10px;
  z-index: 1;
  transition: width 0.7s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 节点组 - 关键修改：多节点自适应宽度 */
.timeline-nodes {
  display: flex;
  /* 替换space-between为gap，避免节点挤压 */
  gap: 20px;
  align-items: flex-start;
  position: relative;
  z-index: 2;
  /* 节点容器最小宽度适配 */
  min-width: 100%;
}

/* ==================== 单个节点 ==================== */
.tl-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 关键：节点宽度自适应，同时限制最小宽度 */
  flex: 0 0 auto;
  width: 167px;
  min-width: 110px;
  position: relative;
  cursor: default;
  transition: transform var(--transition-smooth);
}
.tl-node:hover {
  transform: translateY(-5px);
  z-index: 10;
}
.tl-node:hover .node-plate {
  box-shadow: var(--shadow-lg), 0 0 0 1px rgba(59, 130, 246, 0.1);
}

/* 圆点容器 */
.node-dot-wrap {
  position: relative;
  z-index: 3;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.node-dot {
  width: 16px;
  height: 16px;
  border-radius: var(--radius-full);
  background: var(--white);
  border: 2.5px solid var(--gray-300);
  transition: all var(--transition-smooth);
  position: relative;
  flex-shrink: 0;
}

/* 已完成 */
.tl-node.done .node-dot {
  background: var(--blue-500);
  border-color: var(--blue-500);
  box-shadow: 0 0 0 5px rgba(59, 130, 246, 0.1);
}
.tl-node.done .node-dot::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 9px;
  color: #fff;
  font-weight: 700;
  line-height: 1;
}

/* 进行中 */
.tl-node.active .node-dot {
  width: 22px;
  height: 22px;
  background: #fff;
  border: 3.5px solid var(--blue-600);
  box-shadow: var(--shadow-glow);
  animation: dotPulse 2s ease-in-out infinite;
}
.tl-node.active .node-dot::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  background: var(--blue-600);
}

@keyframes dotPulse {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(59, 130, 246, 0.15), 0 0 30px rgba(59, 130, 246, 0.25);
  }
  50% {
    box-shadow: 0 0 0 16px rgba(59, 130, 246, 0.04), 0 0 44px rgba(59, 130, 246, 0.35);
  }
}

/* 待开始 */
.tl-node.pending .node-dot {
  background: #fff;
  border-color: var(--gray-300);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.015);
}

/* ==================== 信息卡片 ==================== */
.node-plate {
  background: var(--white);
  border-radius: var(--radius-md);
  padding: 16px 12px 14px;
  /* 卡片宽度跟随节点宽度 */
  width: 100%;
  text-align: center;
  box-shadow: var(--shadow-xs);
  border: 1.5px solid var(--gray-200);
  transition: all var(--transition-smooth);
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 7px;
  cursor: pointer;
}

/* 已完成卡片 */
.tl-node.done .node-plate {
  border-color: var(--blue-100);
  background: linear-gradient(180deg, #fdfeff 0%, var(--blue-50) 100%);
  box-shadow: var(--shadow-sm);
}

/* 进行中卡片 */
.tl-node.active .node-plate {
  border-color: var(--blue-400);
  background: #fefeff;
  box-shadow: var(--shadow-md), 0 0 0 5px rgba(59, 130, 246, 0.05);
  /* 进行中卡片略宽 */
  width: 167px;
  padding: 18px 14px 16px;
}

/* 待开始卡片 */
.tl-node.pending .node-plate {
  border-color: var(--gray-200);
  background: var(--gray-50);
  box-shadow: none;
  opacity: 0.72;
}

/* --- 卡片内部元素 --- */
.plate-period {
  font-size: 12.5px;
  font-weight: 700;
  color: var(--gray-600);
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.tl-node.done .plate-period {
  color: var(--blue-600);
}
.tl-node.active .plate-period {
  color: var(--blue-700);
  font-size: 13.5px;
}
.tl-node.pending .plate-period {
  color: var(--gray-500);
}

/* 时间信息 - 优化换行 */
.plate-time {
  font-size: 10px;
  color: var(--gray-500);
  line-height: 1.65;
  letter-spacing: 0.15px;
  /* 强制换行优化 */
  word-wrap: break-word;
}
.plate-time .t-label {
  display: inline-block;
  width:100%;
  font-weight: 600;
  color: var(--gray-400);
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-right: 2px;
}
.plate-time .t-val {
  color: var(--gray-600);
  font-family: var(--font-mono);
  font-size: 12px;
  /* 优化时间显示换行 */
  word-break: break-all;
  display: inline-block;
}
.tl-node.active .plate-time .t-val {
  color: var(--gray-700);
}

/* 分数 */
.plate-score {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--blue-500);
  color: #fff;
  font-size: 14px;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-full);
  margin: 3px auto;
  letter-spacing: 0.5px;
  box-shadow: 0 3px 10px rgba(59, 130, 246, 0.3);
  transition: all var(--transition-smooth);
}
.tl-node.active .plate-score {
  background: var(--blue-600);
  width: 50px;
  height: 50px;
  font-size: 19px;
  box-shadow: 0 5px 18px rgba(37, 99, 235, 0.4);
}
.tl-node.pending .plate-score {
  background: transparent;
  color: var(--gray-400);
  box-shadow: none;
  font-size: 11px;
  font-weight: 500;
  width: auto;
  height: auto;
  border: 1.5px dashed var(--gray-300);
  padding: 6px 12px;
  border-radius: var(--radius-full);
}
.plate-score.score-exam {
  background: #fff;
  color: var(--blue-600);
  border: 2px dashed var(--blue-400);
  font-size: 10.5px;
  font-weight: 600;
  width: auto;
  height: auto;
  padding: 5px 10px;
  border-radius: var(--radius-full);
  box-shadow: none;
  letter-spacing: 0.3px;
}

/* 内容描述 - 优化多行显示 */
.plate-desc {
  font-size: 11px;
  color: var(--gray-600);
  line-height: 1.5;
  letter-spacing: 0.15px;
  /* 允许多行显示 */
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.tl-node.active .plate-desc {
  color: var(--gray-700);
  font-weight: 500;
}
.tl-node.pending .plate-desc {
  color: var(--gray-400);
}

/* 进行中徽章 */
.badge-active {
  display: inline-block;
  background: transparent;
  color: red;
  font-size: 12px;
  font-weight: 700;
  padding: 5px 15px;
  border-radius: var(--radius-full);
  letter-spacing: 0.5px;
  animation: badgeShimmer 2.5s ease-in-out infinite;
  align-self: center;
  border: 2px dashed var(--blue-600);
}
@keyframes badgeShimmer {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.articl_type{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
</style>